import { taskMiddleware } from 'react-palm/tasks';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { thunk } from 'redux-thunk'; // Middleware for async actions like Cube.js
import { api } from '../services/api';
import { CLEAR_STORE } from './actions/general';
import filtersReducer from './reducers/filters';
import generalReducer from './reducers/general';
import mapReducer from './reducers/map';
import modalsReducer from './reducers/modals';
import { layerOpacityReducer, layerVisReducer } from './reducers/layers';

import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['general', 'modals'],
  blacklist: [api.reducerPath],
};

const reducer = combineReducers({
  [api.reducerPath]: api.reducer,
  general: generalReducer,
  map: mapReducer,
  modals: modalsReducer,
  filters: filtersReducer,
  layerVis: layerVisReducer,
  layerOpacity: layerOpacityReducer,
});

const rootReducer = (state, action) => {
  if (action.type === CLEAR_STORE) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

const middleware = [api.middleware, thunk, taskMiddleware];

// if (process.env.NODE_ENV === 'development') {
//   const { logger } = require('redux-logger');
//   middleware.push(logger);
// }

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, {}, applyMiddleware(...middleware));

export const persistor = persistStore(store);
